import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="dynamic-rows"
export default class extends Controller {
  static targets = ['container', 'templateRow', 'row']

  declare readonly containerTarget: HTMLElement
  declare readonly templateRowTarget: HTMLTemplateElement
  declare readonly rowTargets: HTMLElement[]

  add (): void {
    const row = this.templateRowTarget.content.cloneNode(true)
    this.containerTarget.appendChild(row)
  }

  remove (event: Event): void {
    const row = (event.currentTarget as HTMLElement).closest('[data-dynamic-rows-target="row"]')
    if (row !== null) {
      row.remove()
    }
  }
}
